// AUTO-GENERATED — This file is generated code that can be modified.
//     To regenerate: `just codegen-experiment-function … --frontend-client --target-app ask`
//     Note: Manual changes will be lost if regenerated.
import { makeBooleanFlagValueHook } from '#pplx/frontend/experimentation/hooks.js';
export const useExplicitFreeTurnBrandingVariation = makeBooleanFlagValueHook('explicit-free-turn-branding');
//# sourceMappingURL=useExplicitFreeTurnBrandingVariation.js.map